module.exports = __webpack_public_path__ + "static/img/6.6cd152e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mentmo/6/6.png
// module id = 5Hlv
// module chunks = 0